import api from '../../services/api.service';
import { validate } from './validations';
import { build } from '../../services/crudFactory';
import { Action } from '../../services/actions.factory';
const BASE_PATH = '/lognex/companies';
const prefix = 'crudEmpresa';
const crud = build(validate, BASE_PATH);

const newTypes = {
    SET_LOOKUP_PESSOA_VISIBLE: `${prefix}setLookupPessoaVisible`,
}

const actions = new Action(prefix, crud);

const types = Object.assign({}, actions.types, newTypes);


actions.setLookupEmpresaVisible = (visible) => {
    return {
        type: types.SET_LOOKUP_PESSOA_VISIBLE,
        visible
    }
}

actions.loadCompanies = () => {
    return async (dispatch, getState) => {
        dispatch(actions.showLoader());
        try {
            const body = {
                page: getState().crudEmpresaState.page,
                max: getState().crudEmpresaState.max,
                sortField: getState().crudEmpresaState.sortField,
                sortOrder: getState().crudEmpresaState.sortOrder,
                owner: getState().appState.currentCompany.owner,
            }
            await api.post(`/api/v1${BASE_PATH}/find-all-with-owner-and-parent`, body)
                .then((response) => {
                    if(response.data && response.data.records.length > 0){
                        dispatch(actions.setRecords(response.data.records));
                        dispatch(
                        actions.messageActions.messageShowMessages(
                            makeMessages(["Empresas carregadas com sucesso."], "success")
                        )
                      );
                    }else{
                        dispatch(actions.setRecords([]));
                        dispatch(
                            actions.messageActions.messageShowMessages(
                                makeMessages(["Nenhuma empresa encontrada."], "error")
                            )
                        );
                    }
                })
        } catch (error) {
            dispatch(actions.setRecords([]));
            dispatch(
                actions.messageActions.messageShowMessages(
                    makeMessages(["Não foi possível carregar as empresas."], "error")
                )
              );
        } finally {
            dispatch(actions.hideLoader());
        }
    }
}

actions.loadCompanyById = (id) => {
    return async (dispatch, getState) => {
        dispatch(actions.showLoader());
        const body = {
            id
        }
        try {
            const result = await api.post(`/api/v1${BASE_PATH}/find-by-id-without-owner`, body);
            dispatch(actions.setRecord(result.data));
            dispatch(
                actions.messageActions.messageShowMessages(
                    makeMessages(["Empresa carregada com sucesso."], "success")
                )
            )
        } catch (error) {
            dispatch(actions.setRecord(null));
            dispatch(actions.messageActions.messageShowMessages(makeMessages(["Não foi possível carregar a empresa."], "error")));
        } finally {
            dispatch(actions.hideLoader());
        }

    }
}


function makeMessages(messages, type) {
    return messages.map(message => {
        return { sticky: true, severity: type, detail: message };
    });
};



export { types, actions };